import useScorms from '@hooks/useScorms'
import {
  checkboxField,
  numberField,
  textField,
  fileField,
} from '@templates/AddNewItemModal/templates'
import { Fields } from '@templates/AddNewItemModal/Content'
import selectSearchField from '@templates/AddNewItemModal/templates/selectSearchField'

const LABELS = {
  title: 'Название темы',
  hoursCount: 'Количество часов',
  hoursPlaceholder: 'Количество часов',
  hasTest: 'Содержит тест',
} as const

type UseThemeFormFieldsOptions = {
  internalCourseMode?: boolean
  isEdit?: boolean
}

const useThemeFormFields = (
  options: UseThemeFormFieldsOptions = {}
): Fields => {
  const { internalCourseMode = false, isEdit = false } = options
  // Селект SCORM есть только в витрине (в клиентских курсах вместо него загрузка
  // файла), а там работают только общие темы, поэтому клиентские в выпадашку не
  // отдаём: выбрать такую тему всё равно нельзя, бэк отобьёт по правилу.
  const { data, isLoading, setFilters, setPage } = useScorms({
    forcedFilters: { 'course.isClientCourse': false },
  })
  const { items = [], length = 0 } = data || {}

  const commonFields = {
    title: textField({
      name: 'title',
      label: LABELS.title,
      isRequired: true,
      placeholder: LABELS.title,
      id: 'theme-title',
    }),
    hoursTime: numberField({
      name: 'hoursTime',
      label: LABELS.hoursCount,
      placeholder: LABELS.hoursPlaceholder,
      id: 'theme-hours-time',
      componentProps: {
        maskOptions: {
          // Часы только целые (без дробной части).
          scale: 0,
          normalizeZeros: true,
        },
      },
    }),
    test: checkboxField({
      name: 'test',
      label: LABELS.hasTest,
    }),
  }

  if (internalCourseMode) {
    return [
      {
        fields: [
          commonFields.title,
          fileField({
            name: 'file',
            label: 'Загрузить (PDF, SCORM)',
            isRequired: !isEdit,
            id: 'theme-file',
            formats: ['pdf', 'zip'],
            maxSizeMegaBytes: 500,
          }),
        ],
        lineId: 'theme-main-fields',
      },
      {
        fields: [commonFields.hoursTime],
        lineId: 'theme-hours-field',
      },
    ]
  }

  return [
    {
      fields: [
        commonFields.title,
        selectSearchField({
          label: 'Выбрать SCORM',
          name: 'courseTheme',
          isRequired: true,
          options: items,
          isLoading,
          setFilters,
          setPage,
          length,
          isClearable: false,
        }),
        commonFields.hoursTime,
        commonFields.test,
      ],
      lineId: 'theme-catalog-fields',
    },
  ]
}

export default useThemeFormFields
